import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { log } from 'src/app/caisse/caisse/caisse.component';
import { ChampRD_Type } from 'src/app/models/champD.type';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2/dist/sweetalert2.js';

@Component({
  selector: 'app-simed-analyse',
  templateUrl: './simed-analyse.component.html',
  styleUrls: ['./simed-analyse.component.scss'],
})
export class SimedAnalyseComponent implements OnInit, AfterViewInit {
  ChampRD_Type = ChampRD_Type;

  formGroup: FormGroup;
  propNames = [];

  api = environment.apiEndPoint;
  ds;

  options = { placeholder: 'AE' };

  constructor(
    private fb: FormBuilder,
    private generalService: GeneralService
  ) {}

  ngOnInit(): void {
    this.getDS();
  }

  ngAfterViewInit() {}

  buildFormGroup(item) {
    if (!this.formGroup) {
      this.getStructure();
    } else {
      this.setValues(item);
    }
  }

  setValues(item) {
    this.propNames.forEach((element) => {
      if (item[element.TableRD_Champs]) {
        this.formGroup
          .get(element.TableRD_Champs)
          .setValue(item[element.TableRD_Champs]);
      }
    });
  }

  getStructure() {
    this.generalService.tbRecherche('GammeD').subscribe((res: any) => {
      this.formGroup = this.fb.group({});
      let structure = res.TableRD;
      structure = structure.sort(
        (n1, n2) => n1.TableRD_Ordre - n2.TableRD_Ordre
      );
      structure.forEach((element) => {
        if (!this.formGroup.contains(element.TableRD_Champs)) {
          this.formGroup.addControl(
            element.TableRD_Champs,
            this.fb.control(null)
          );
          this.propNames.push(element);
        }
      });
    });
  }

  handleAdd() {
    this.getDS();
  }
  handleUpdate() {
    Object.assign(this.ds.GammeD[0], this.formGroup.value);
    this.generalService.enregisterTable(this.ds).subscribe((res) => {
      this.getDS();
    });
  }
  handleDelete() {
    Swal.fire({
      title: 'Êtes-vous sur ?',
      text: 'Ceci est irreversible.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        this.generalService.supprimer(this.ds.Gamme[0].GammeD_Id, 'GammeD');
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        Swal.fire('Annulé', "Rien n'a été supprimé", 'error');
      }
    });
  }
  handleSelect(item) {
    this.buildFormGroup(item);
  }
  handleImprimer() {}

  getDS() {
    this.generalService.getDS('GammeD').subscribe((ds) => {
      this.ds = ds;
      this.buildFormGroup(this.ds.GammeD[0]);
    });
  }

  save() {
    Object.assign(this.ds.GammeD[0], this.formGroup.value);
    this.generalService.enregisterTable(this.ds).subscribe((res) => {
      this.getDS();
    });
  }
}
